/**
 * Read the value of the --transition-duration variable from CSS
 */ function getTransitionDuration(element) {
    return cssTimeToMs(window.getComputedStyle(element).getPropertyValue('--st-transition-duration'));
}
function cssTimeToMs(time) {
    const t = parseFloat(time);
    if (Number.isNaN(t)) return 0;
    return time.endsWith('ms') ? t : t * 1000;
}

export { getTransitionDuration };
//# sourceMappingURL=animation.mjs.map
